import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { SlidersHorizontal } from 'lucide-react';
import { PageShareTitle } from '../../lib/shareTitle';
import { getStoredFunMode, translate } from '../i18n';

const adminPage = PageBlueprint.make({
  name: 'shared-actions-version',
  params: {
    path: '/admin',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note.
    title: translate('admin.page.title', getStoredFunMode()),
    icon: <SlidersHorizontal size={20} strokeWidth={2} />,
    noHeader: true,
    loader: () =>
      import('./AdminPage').then(m => (
        <PageShareTitle title="Admin">
          <m.AdminPage />
        </PageShareTitle>
      )),
  },
});

export const adminPlugin = createFrontendPlugin({
  pluginId: 'admin',
  extensions: [adminPage],
});
